define.alias("ember-math-helpers/helpers/sum", "media/helpers/sum");